
import { Vue } from "vue-class-component";

import storage from "@/storage";
import { IAuthStorage, ISiteStorage } from "@/storage/model";
import topMenuBloc from "./services/bloc";
import guard from "@/guard";
import authBloc from "@/modules/auth/services/bloc";
import { LogoutResponse } from "../types";

export abstract class BaseTopMenu extends Vue {
  loginBloc = authBloc;
  topMenuBloc = topMenuBloc
  searchFocusClass: string = "w-25";
  options: any = null;
  showSearch = false;
  openSearch = false;
  focusSearch = false;
  username = '';
  userId = '';
  showAlarm = false;
  routePathEquipment: string = "";
  alarmMessage: string = "";
  showSite = true;
  isShow = false;

  async mounted() {
    try {
      const siteStorage: ISiteStorage = await storage.get<ISiteStorage>(storage.SITE);
      const site = await this.topMenuBloc.getSite(siteStorage.id);
      if (site) {
        this.options = site;
      }
    } catch (e) {

    }
  }


  async goAuthSite() {
    await storage.clear(storage.SITE_AUTH);
    this.$router.push(`/auth/site`);
  }


  goToMonitor() {
    if (this.routePathEquipment == "") return;
    this.$router.push(`/monitor/${this.routePathEquipment}/`);
  }

  openMenu() {
    const open = 'nav-open g-sidenav-show g-sidenav-pinned';
    const close = 'g-sidenav-hidden';
    document.body.className = document.body.className == close ? open : close;
  }

  async logout() {
    try {
      const auth: IAuthStorage = await storage.get<IAuthStorage>(storage.AUTH);
      const response: LogoutResponse = await this.topMenuBloc.logout({
        type:  auth.type,
        login: `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}/#/auth/login`
      });
      await guard.logout();
      if(response.is_redirect) {
        window.location.href = response.redirect;
      }
    } catch (e) {}
  }

  async toggleActionSheet() {
    this.isShow = !this.isShow;
  }
}